import { Injectable } from '@angular/core';

/**
 * Use this service to execute arbitrary functions one at a time in a FIFO
 * queue. E.g. it is used to organize submissions & autosaving so they cannot be
 * in flight at the same time and execute out of order (to avoid edge cases in
 * error handling).
 *
 * From https://stackoverflow.com/a/46539032.
 */
@Injectable({ providedIn: 'root' })
export class ExecutionQueueService {
  private head = Promise.resolve();

  enqueue(fn: () => Promise<void> | undefined) {
    return new Promise<void>(
      (resolve, reject) =>
        (this.head = this.head.then(() =>
          Promise.resolve(fn()).then(resolve, reject),
        )),
    );
  }
}
